import Home from "../pages/Home";
import Login from "../pages/Login";
import Subscribe from "../pages/Subscribe";
import Video from "../pages/Video";
import VideosFeed from "../pages/VideosFeed";

export const id = {
  home: "home",
  video: "video",
  feed: "feed",
  login: "login",
  subscribe: "subscribe",
  redirect: "redirect",
};

export const path = {
  home: "/",
  video: "/catagory/:catId/content/:vidId",
  feed: "/catagory/:catId",
  login: "/login",
  subscribe: "/subscribe",
  redirect: "/redirect",
};

export const routes = [
  {
    id: id.video,
    path: path.video,
    component: <Video />,
  },
  {
    id: id.feed,
    path: path.feed,
    component: <VideosFeed />,
  },
];

export const fullPagesRoutes = [
  // {
  //   id: id.subscribe,
  //   path: path.subscribe,
  //   component: <Subscribe />,
  // },
  {
    id: id.login,
    path: path.login,
    component: <Login />,
  },
  {
    id: id.redirect,
    path: path.redirect,
    component: <Login />,
  },
  {
    id: id.home,
    path: path.home,
    component: <Home />,
  },
];

// export const protectedFullPagesRoutes = [
// {
//   id: id.home,
//   path: path.home,
//   component: <Home />,
// },
// ];
